import React from 'react';
import * as S from '../styles/My015Charge.styles';
import { parseInt } from 'lodash';
import {
  ARREO_LMS,
  ARREO_MMS,
  ARREO_SMS,
  WORKS015_LMS,
  WORKS015_MMS,
  WORKS015_PROMO1,
  WORKS015_PUSH,
  WORKS015_SMS,
  WORKS015_STT,
  WORKS015_TTS,
} from '@/shared/constants';

/**
 * @title 015 구독 결제 - 015 서비스에 대한 금액 , 서비스 종류 안내 컴포넌트
 *
 * @author 정휘학
 * @since 2024.05.17
 * */

const My015ChargeBottom = () => {
  return (
    <S.Guide>
      <li>&#183; 음성, 문자 수신 서비스는 무료로 이용 가능합니다.</li>
      <li>&#183; 015 번호로 보내는 단건 문자는 무료입니다. 015 번호로 보내는 단체 문자는 비용이 청구됩니다.</li>
      <li>
        &#183; 1건당 &quot;일반문자: {WORKS015_SMS}원 / 장문문자: {WORKS015_LMS}원 / 포토문자: {WORKS015_MMS}원&quot;이
        차감됩니다.
      </li>
      <li>&#183; SMS는 단문(90byte), LMS는 장문(1,985Byte)입니다.</li>
      <li>
        &#183; 문자 알림 서비스는 웹 Push 알림 기본 제공이며, 문자로 알림 수신을 원하시는 경우 건당 {WORKS015_PUSH}원의
        요금이 발생합니다.
      </li>
      <li>&#183; 잔액이 부족할 경우 문자 발송이 제한됩니다.</li>
      <li>
        &#183; &#39;010&#39; 번호로 문자를 발송하고 싶은 경우에는 캐시 충전이 필요합니다. 010번호로 문자 전송 시 1건당
        &quot;일반문자: {ARREO_SMS}원 / 장문문자: {ARREO_LMS}원 / 포토문자: {ARREO_MMS}원&quot;이 차감됩니다.
      </li>
      {/* TODO - stt, tts 주석 */}
      {/* <li>
        &#183; STT 변환은 Speech to Text의 약자로, 음성을 텍스트로 변환시켜주는 서비스입니다. 음성녹음을 텍스트로 변환할
        때 사용합니다. 월 5분 제공. 추가 변환 시 분당 {parseInt(WORKS015_STT as string) * 60}
        원의 비용이 발생합니다. (1분까지 변환 가능합니다.)
      </li>
      <li>
        &#183; TTS 변환은 Text to Speech의 약자로, 텍스트를 음성으로 변환시켜주는 서비스입니다. 안내멘트 녹음시
        사용됩니다. 일일 작성 회수 5건 제공. 추가 수정 시 건당 {WORKS015_TTS}원의 비용이 발생합니다.
      </li> */}

      <p>
        &#42; 월 결제 기준으로 서비스 이용이 시작된 후 단순 변심에 의한 환불은 불가합니다. 고객이 서비스 이용을 시작하지
        않은 상태에서만 결제가 이루어진 당월에 전액 환불 가능합니다. 연간 통신료 결제는 이용 기간에 따라 비례 환불이
        가능합니다.
      </p>
    </S.Guide>
  );
};

export default My015ChargeBottom;
